import React, { useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@mui/material";
import InstrumentDataFileUploader from "../../common/InstrumentDataFileUploader";

const EliICPMS = () => {
  const [fileData, setFileData] = useState([]);

  const handleGetData = ({ fileContent }) => {
    const rows = fileContent.split("\n").map(row => row.split("\t"));
    setFileData(rows);
  };

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        ICPMS Data File Uploader
      </Typography>
      <InstrumentDataFileUploader  onGetData={handleGetData} />

      {fileData.length > 0 && (
        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                {fileData[0].map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {fileData.slice(1).map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <TableCell key={cellIndex}>{cell}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default EliICPMS;
